import React, { useState, useEffect } from 'react'
import { Input, Button, Table, message } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { listCourse, delCourse } from '../../../http/modules/organization'
import { useNavigate } from "react-router-dom";
import Amend from './amend'
const { Search } = Input;

export default function ApplyList() {

  const navigate = useNavigate();

  const [selectionType, setSelectionType] = useState('checkbox');
  // 参赛老师
  const [playerlist, setPlayerlist] = useState()
  // 报名老师id
  const [playerId, setPlayerId] = useState()
  // 选中的 id
  const [arrId, setArrID] = useState()

  const columns = [
    {
      title: '授课人',
      dataIndex: 'playerName',
      key: 'playerName',
      className:'table'
    },
    {
      title: '手机号',
      dataIndex: 'playerPhone',
      key: 'playerPhone',
      className:'table'
    },
    {
      title: '课程名称',
      dataIndex: 'title',
      key: 'title',
      className:'table'
    },
    {
      title: '课程类别',
      dataIndex: 'category',
      key: 'category',
      className:'table'
    },
    {
      title: '授课类型',
      dataIndex: 'typ',
      key: 'typ',
      className:'table'
    },
    {
      title: '申报状态',
      dataIndex: 'isFull',
      key: 'isFull',
      className:'table'
    },
    {
      title: '初选成绩',
      dataIndex: '',
      key: '',
      className:'table'
    },
    {
      title: '初选结果',
      dataIndex: '',
      key: '',
      className:'table'
    },
    {
      title: '操作',
      dataIndex: '',
      key: '',
      className:'table',
      render: (event) => (
        <span style={{ color: '#1F78FE', cursor:'pointer'}} onClick={() => setPlayerId(event.key)}>
          修改
        </span>
      )
    }
  ];

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setArrID(selectedRowKeys)
      // console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
    },
    getCheckboxProps: (record) => ({
      disabled: record.name === 'Disabled User',
      // Column configuration not to be checked
      name: record.name,
    }),
  };

  //参赛者列表
  const OnListCourse = async () => {
    const res = await listCourse({
      "pageNo": 1,
      "pageSize": 10000,
    })
    let arr = []
    res.data?.list?.map((item) => {
      arr.push(
        {
          key: item.courseUUID,
          playerName: item.playerName,
          playerPhone: item.playerPhone,
          title: item.title,
          category: item.category,
          typ: item.typ,
          isFull: item.isFull
        },
      )
    })
    setPlayerId('')
    setPlayerlist(arr)
  }

  // 搜索按钮
  const onSearch = async(value) =>{
    const res = await listCourse({
      "pageNo": 1,
      "pageSize": 10000,
      "playerName":value
    })
    let arr = []
    res.data?.list?.map((item) => {
      arr.push(
        {
          key: item.courseUUID,
          playerName: item.playerName,
          playerPhone: item.playerPhone,
          title: item.title,
          category: item.category,
          typ: item.typ,
          isFull: item.isFull
        },
      )
    })
    setPlayerlist(arr)
  };

  // 删除课程
  const remove = async () => {
    if(!arrId){
      message.error('请先选择')
      return
    }
    const res = await delCourse({
      courseUUIDList: arrId
    })
    if (res.code == 0) {
      message.success('删除成功')
      OnListCourse()
    } else {
      message.error('删除失败')
    }
  }

  useEffect(() => {
    OnListCourse()
  }, [])

  return (
    <>
      {playerId ? <Amend courseUUID={playerId} onDone={() => {
        setPlayerId('')
        OnListCourse()
      }} /> : <div className='ApplyList'>
        <header>
          <Search
            placeholder="请输入"
            allowClear
            enterButton="搜索"
            size="large"
            onSearch={onSearch}
          />
          <div className='headerButton'>
            <Button onClick={remove} shape="round" icon={<DeleteOutlined />} size={'large'}>
              删除
            </Button>
            <Button onClick={()=>navigate('/organization/applyAdd')} style={{ marginLeft: '20px' }} type="primary" shape="round" icon={<PlusOutlined />} size={'large'}>
              新建
            </Button>
          </div>
        </header>
        <main>
          <Table rowSelection={{
            type: selectionType,
            ...rowSelection,
          }} dataSource={playerlist} columns={columns} />;
        </main>
      </div>}
    </>
  )
}
